<template>
    <div :class="['sidebar', {open: sidebarOpen}]">
        <header class="logo">
            <router-link tag="a" class="d-block m-auto" exact to="/">
                <span class="icon-logo-expanded icon-cph_iconset_cph_headerlogo"
                      v-if="sidebarOpen"/>
                <span class="icon-logo-collapsed icon-cph_iconset_cloudprinthub pt-4"
                      v-else/>
            </router-link>
        </header>

        <cph-sidebar-navigation/>
        <div>
          <shop-picker></shop-picker>
        </div>
    </div>
</template>

<script type="text/babel">
import {mapGetters, mapMutations} from 'vuex';
import {SidebarPerimeter} from '../../../router/perimeters/sidebarPerimeter';
import CphSidebarNavigation from './CphSidebarNavigation';
import ShopPicker from '@/components/Panel/Account/ShopPicker.vue';

export default {
    name: 'CphSidebar',
    components: {
      CphSidebarNavigation,
      ShopPicker
    },
    perimeters: [
        SidebarPerimeter
    ],
    computed: {
        ...mapGetters({
            sidebarOpen: 'getSidebarOpenFlag'
        })
    },
    methods: {
        ...mapMutations(['updateSidebarOpenFlag'])
    }
};
</script>

<style lang="scss">
    .sidebar {
        @include color('background-color', sidebar-bg);
        @include color('color', text-color-light);
        height: 100vh;
        .logo {
            @include color('background-color', sidebar-logo-bg);
        }
    }


    .logo {
        font-size: 2em;
        height: 50px;
        margin: 0px 0px 0px 0px;
        line-height: 50px;
        text-align: center;
        vertical-align: middle;
        transition: height 0.3s ease-in;

        a {
            text-align: center;
            @include color('color', text-color-light);
            text-decoration: none;
            font-size: 1.6em;
            transition: font-size 0.3s ease-in;
        }
    }

    .open {
        .logo {
            height: 120px;
            a {
                font-size: 4em;
            }
        }
    }


</style>
